import { render } from "./HelloWorld.vue?vue&type=template&id=38425290&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=38425290&scoped=true&lang=css"

import exportComponent from "C:\\Data\\DevEnv\\projects\\Yifat\\pwa\\hello-world4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38425290"]])

export default __exports__